<script>
    export let gamelog = [];
    export let league = "nba";
    export let is_pitcher = false;
    export let is_qb = false;
    export let is_goalie = false;
</script>
<div class="p-2">
    <h2>GameLog</h2>
    <div class="card" style="max-height: 500px; overflow-y:auto; overflow-x:hidden;">
        {#each gamelog as entry, index}
        <div class="p-1 border-bottom">
            <div class="lead text-center">
            <span><span class="fw-normal">{entry["fantasy points"].toFixed(1)}</span> FP </span>
            {#if entry.player_game.team.id == entry.player_game.game.home_team.id}
                <span class="text-muted">VS {entry.player_game.game.away_team.short_name}</span>
            {:else}
                <span class="text-muted">@ {entry.player_game.game.home_team.short_name}</span>
            {/if}
                {new Date(entry.player_game.game.start_time.replace(/-/g, "/")).toLocaleDateString("default",{month:'short', day:"numeric"})}
            </div>
            <div class="text-center">
                {#if league == "nba"}
                <div class="row">
                    <div class="col-2 pb-1 fw-bold border-end">M</div>
                    <div class="col-2 fw-bold border-end">P</div>
                    <div class="col-2 fw-bold border-end">R</div>
                    <div class="col-2 fw-bold border-end">A</div>
                    <div class="col-2 fw-bold border-end">B</div>
                    <div class="col-2 fw-bold">S</div>
                </div>
                <div class="row">
                    <div class="col-2 border-end">{parseInt(entry.minutes)}</div>
                    <div class="col-2 border-end">{entry.points}</div>
                    <div class="col-2 border-end">{parseInt(entry.rebounds)}</div>
                    <div class="col-2 border-end">{parseInt(entry.assists)}</div>
                    <div class="col-2 border-end">{parseInt(entry.blocks)}</div>
                    <div class="col-2">{parseInt(entry.steals)}</div>
                </div>
                {:else if league == "mlb" && is_pitcher}
                <div class="row">
                    <div class="col-2 fw-bold border-end">K</div>
                    <div class="col-2 pb-1 fw-bold border-end">W</div>
                    <div class="col-2 fw-bold border-end">PT</div>
                    <div class="col-2 fw-bold border-end">H</div>
                    <div class="col-2 fw-bold border-end">BB</div>
                    <div class="col-2 fw-bold">ER</div>
                </div>
                <div class="row">
                    <div class="col-2 border-end">{entry.strikeouts}</div>
                    <div class="col-2 border-end">{entry.wins}</div>
                    <div class="col-2 border-end">{entry.pitches_thrown}</div>
                    <div class="col-2 border-end">{entry.hits_allowed}</div>
                    <div class="col-2 border-end">{entry.walks_allowed}</div>
                    <div class="col-2">{entry.earned_runs}</div>
                </div>
                {:else if league == "mlb"}
                <div class="row">
                    <div class="col-2 fw-bold border-end">Hits</div>
                    <div class="col-2 pb-1 fw-bold border-end">Runs</div>
                    <div class="col-2 fw-bold border-end">RBI</div>
                    <div class="col-2 fw-bold border-end">SB</div>
                    <div class="col-2 fw-bold border-end">BB</div>
                    <div class="col-2 fw-bold">K</div>
                </div>
                <div class="row">
                    <div class="col-2 border-end">{parseInt(entry.singles)+parseInt(entry.doubles)+parseInt(entry.triples)+parseInt(entry.homeruns)}</div>
                    <div class="col-2 border-end">{parseInt(entry.runs)}</div>
                    <div class="col-2 border-end">{parseInt(entry.rbis)}</div>
                    <div class="col-2 border-end">{parseInt(entry.stolen_bases)}</div>
                    <div class="col-2 border-end">{parseInt(entry.walks)}</div>
                    <div class="col-2">{parseInt(entry.batter_strikeouts)}</div>
                </div>
                {:else if league == "nfl" && is_qb}
                <div class="row">
                    <div class="col-2 fw-bold border-end">Pass Yds</div>
                    <div class="col-2 pb-1 fw-bold border-end">Pass Tds</div>
                    <div class="col-2 fw-bold">Comp / Att</div>
                    <div class="col-2 fw-bold border-end">Int</div>
                    <div class="col-2 fw-bold border-end">Rush Yds</div>
                    <div class="col-2 fw-bold border-end">Rush Tds</div>
                </div>
                <div class="row">
                    <div class="col-2 border-end">{parseInt(entry.pass_yards)}</div>
                    <div class="col-2 border-end">{parseInt(entry.pass_tds)}</div>
                    <div class="col-2 border-end">{parseInt(entry.completions)} / {parseInt(entry.attempts)}</div>
                    <div class="col-2 border-end">{parseInt(entry.off_interceptions)}</div>
                    <div class="col-2 border-end">{parseInt(entry.rush_yards)}</div>
                    <div class="col-2">{parseInt(entry.rush_tds)}</div>
                </div>
                {:else if league == "nhl" && is_goalie}
                <div class="row">
                    <div class="col-2 fw-bold border-end">SV</div>
                    <div class="col-2 pb-1 fw-bold border-end">SA</div>
                    <div class="col-2 fw-bold border-end">GA</div>
                    <div class="col-2 fw-bold border-end">W</div>
                    <div class="col-2 fw-bold border-end">SO</div>
                    <div class="col-2 fw-bold">TOI</div>
                </div>
                <div class="row">
                    <div class="col-2 border-end">{parseInt(entry.saves)}</div>
                    <div class="col-2 border-end">{parseInt(entry.shots_against)}</div>
                    <div class="col-2 border-end">{parseInt(entry.goals_against)}</div>
                    <div class="col-2 border-end">{parseInt(entry.wins)}</div>
                    <div class="col-2 border-end">{parseInt(entry.shutouts)}</div>
                    <div class="col-2">{parseFloat(entry.time_on_ice).toFixed(0)}</div>
                </div>
                {:else if league == "nhl"}
                <div class="row">
                    <div class="col-2 fw-bold border-end">G</div>
                    <div class="col-2 pb-1 fw-bold border-end">A</div>
                    <div class="col-2 fw-bold border-end">SOG</div>
                    <div class="col-2 fw-bold border-end">BLK</div>
                    <div class="col-2 fw-bold border-end">PPP</div>
                    <div class="col-2 fw-bold">TOI</div>
                </div>
                <div class="row">
                    <div class="col-2 border-end">{parseInt(entry.goals)}</div>
                    <div class="col-2 border-end">{parseInt(entry.assists)}</div>
                    <div class="col-2 border-end">{parseInt(entry.shots)}</div>
                    <div class="col-2 border-end">{parseInt(entry.blocked_shots)}</div>
                    <div class="col-2 border-end">{parseInt(entry.power_play_goals) + parseInt(entry.power_play_assists)}</div>
                    <div class="col-2">{parseFloat(entry.time_on_ice).toFixed(1)}</div>
                </div>
                {:else if league == "nfl"}
                <div class="row">
                    <div class="col-2 fw-bold border-end">Rec Yds</div>
                    <div class="col-2 pb-1 fw-bold border-end">Rec Tds</div>
                    <div class="col-2 fw-bold">Receptions</div>
                    <div class="col-2 fw-bold border-end">Targets</div>
                    <div class="col-2 fw-bold border-end">Rush Yds</div>
                    <div class="col-2 fw-bold border-end">Rush Tds</div>
                </div>
                <div class="row">
                    <div class="col-2 border-end">{parseInt(entry.rec_yards)}</div>
                    <div class="col-2 border-end">{parseInt(entry.rec_tds)}</div>
                    <div class="col-2 border-end">{parseInt(entry.receptions)}</div>
                    <div class="col-2 border-end">{parseInt(entry.targets)}</div>
                    <div class="col-2 border-end">{parseInt(entry.rush_yards)}</div>
                    <div class="col-2">{parseInt(entry.rush_tds)}</div>
                </div>
                {/if}
            </div>
        </div>
        {/each}
    </div>
</div>